// Call the existing element from html file
export const article = document.querySelector('article.article-app');
export const addListBtn = document.querySelector('button.addList');
export const searchByName = document.querySelector('input.searchName');
export const searchByMonth = document.querySelector('select.searchMonth');
export const formSearch = document.querySelector('form.formSearch');
export const resetSearch = document.querySelector('button.resetSearch');